module.exports = __webpack_public_path__ + "img/antes_despues_272.feebe0d9.png";